// Soul Mosaic item types and helpers. The visible UI stays quiet and editorial;
// the data model can expand without turning the space into a feed.

export const MOSAIC_TYPES = {
  quote: {
    id: "quote",
    label: "Words",
    plural: "Words",
    color: "#FBF6EF",
    accent: "#7A5C63",
    icon: "quote",
    promptPlaceholder: "A line that holds you steady…",
  },
  photo: {
    id: "photo",
    label: "Photo",
    plural: "Photos",
    color: "#F3E9DF",
    accent: "#8E6C88",
    icon: "image",
    promptPlaceholder: "A caption (optional)…",
  },
  song: {
    id: "song",
    label: "Song",
    plural: "Songs",
    color: "#E9D9E0",
    accent: "#5B3954",
    icon: "music",
    promptPlaceholder: "Why this one…",
  },
  movie: {
    id: "movie",
    label: "Film",
    plural: "Films",
    color: "#EEE5DE",
    accent: "#6A5669",
    icon: "film",
    promptPlaceholder: "What stayed with you…",
  },
  book: {
    id: "book",
    label: "Book",
    plural: "Books",
    color: "#F2E9D8",
    accent: "#7B624A",
    icon: "book",
    promptPlaceholder: "What this opened up for you…",
  },
  place: {
    id: "place",
    label: "Place",
    plural: "Places",
    color: "#E7EADF",
    accent: "#587064",
    icon: "mapPin",
    promptPlaceholder: "Why this place matters…",
  },
  memory: {
    id: "memory",
    label: "Memory",
    plural: "Memories",
    color: "#F1E1DC",
    accent: "#8A5D62",
    icon: "heart",
    promptPlaceholder: "A moment you want to keep…",
  },
  message: {
    id: "message",
    label: "Message",
    plural: "Messages",
    color: "#F0E4D8",
    accent: "#5C4A57",
    icon: "messageCircleHeart",
    promptPlaceholder: "What they said that landed…",
  },
  person: {
    id: "person",
    label: "Person",
    plural: "People",
    color: "#F3E4E1",
    accent: "#81545C",
    icon: "userRound",
    promptPlaceholder: "What you want to remember about them…",
  },
  experience: {
    id: "experience",
    label: "Experience",
    plural: "Experiences",
    color: "#F5EEDC",
    accent: "#8A6D43",
    icon: "sparkles",
    promptPlaceholder: "Why this experience belongs here…",
  },
  project: {
    id: "project",
    label: "Project",
    plural: "Projects",
    color: "#E7E5EE",
    accent: "#635D7E",
    icon: "blocks",
    promptPlaceholder: "What you are building or why it matters…",
  },
  reminder: {
    id: "reminder",
    label: "Anchor",
    plural: "Anchors",
    color: "#E9DED3",
    accent: "#4A6B5D",
    icon: "anchor",
    promptPlaceholder: "A reason to stay grounded…",
  },
};

export const MOSAIC_TYPE_ORDER = [
  "quote",
  "photo",
  "song",
  "movie",
  "book",
  "place",
  "person",
  "experience",
  "project",
  "memory",
  "message",
  "reminder",
];

export const rotationForId = (id) => {
  if (!id) return 0;
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) | 0;
  const range = 64;
  return ((h % range) - range / 2) / 10;
};

export const offsetForId = (id) => {
  if (!id) return 0;
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 17 + id.charCodeAt(i)) | 0;
  return Math.abs(h % 16) - 8;
};
